module.exports = __webpack_public_path__ + "img/photo5.e12ca2a3.png";